import React, { useState, useEffect } from "react";

export default function ShortlistRemovalModal({
    show,
    seller,
    onConfirm,
    onCancel,
    reasons = ["High Price", "Low Quality", "Not Trustable Provider"],
}) {
    const [option, setOption] = useState("");
    const [details, setDetails] = useState("");

    useEffect(() => {
        setOption("");
        setDetails("");
    }, [show]);

    if (!show || !seller) return null;

    const handleConfirm = () => {
        if (!option) {
            alert("Please select a reason.");
            return;
        }
        onConfirm(option, details);
    };

    return (
        <div
            className="modal fade show d-block shortlist-removal-modal"
            tabIndex="-1"
            style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 1200 }}
            onClick={onCancel}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: "450px" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content p-4 rounded-3">
                    <div className="d-flex justify-content-center mb-3">
                        <img
                            src="/images/remove.svg"
                            alt={seller.name}
                            className="rounded-circle"
                            width={90}
                            height={90}
                        />
                    </div>

                    <h5 className="fw-bold mb-2 text-start" style={{ color: "#071437" }}>
                        You’re about to remove Proposal from Shortlist
                    </h5>
                    <p className="mb-3 text-start" style={{ color: "#80829A", fontSize: "14px" }}>
                        Are you sure you want to delete <strong>{seller.name}</strong>’s proposal from Shortlist?
                        This action couldn’t be restored.
                    </p>

                    <h6 className="fw-bold mb-3 text-start" style={{ color: "#071437" }}>
                        Please select the reason for removal
                    </h6>

                    <div className="mb-3 text-start">
                        {reasons.map((r) => (
                            <div key={r} className="form-check mb-2">
                                <input
                                    type="radio"
                                    id={r}
                                    name="removeReason"
                                    className="form-check-input"
                                    value={r}
                                    checked={option === r}
                                    onChange={(e) => setOption(e.target.value)}
                                />
                                <label htmlFor={r} className="form-check-label">
                                    {r}
                                </label>
                            </div>
                        ))}
                    </div>

                    <label className="form-label text-start d-block" style={{ color: "#181D4C" }}>
                        Please tell us more
                    </label>
                    <textarea
                        className="form-control mb-4"
                        rows="3"
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                        placeholder="Share the reason of removal please"
                    ></textarea>

                    <div className="d-flex justify-content-evenly gap-2">
                        <button className="btn w-100 btn-outline-dark px-3" onClick={onCancel}>
                            Cancel Removal
                        </button>
                        <button
                            className="btn w-100 px-3"
                            style={{ backgroundColor: "#181D4C", color: "#fff" }}
                            onClick={handleConfirm}
                        >
                            Remove Anyway
                        </button>
                    </div>
                </div>
            </div>

            <style>
                {`.shortlist-removal-modal .form-check-input:checked {
          background-color: #000 !important;
          border-color: #000 !important;
        }`}
            </style>
        </div>
    );
}
